import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Marker } from "@vfit/ui/icons";
import { requireStaticImageComponent } from "@vfit/shared/data-access";
import { IconButtonsWrapper, IconMarkerWrapper, LeftButton, MainContainer, OtherActionsContainer, RightButton } from "./footer.style";
var Footer = function(param) {
    var otherInfo = param.otherInfo;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var handlerClick = function(url) {
        window.open(url, "_blank");
    };
    return /*#__PURE__*/ _jsx(MainContainer, {
        children: /*#__PURE__*/ _jsxs(OtherActionsContainer, {
            children: [
                otherInfo && (otherInfo === null || otherInfo === void 0 ? void 0 : (ref = otherInfo[0]) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ _jsxs(LeftButton, {
                    onClick: function() {
                        return handlerClick(otherInfo[0].url);
                    },
                    children: [
                        /*#__PURE__*/ _jsx(IconButtonsWrapper, {
                            children: /*#__PURE__*/ _jsx(Marker, {})
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: otherInfo[0].info
                        })
                    ]
                }),
                otherInfo && (otherInfo === null || otherInfo === void 0 ? void 0 : (ref1 = otherInfo[1]) === null || ref1 === void 0 ? void 0 : ref1.url) && /*#__PURE__*/ _jsxs(RightButton, {
                    onClick: function() {
                        var ref;
                        return handlerClick((otherInfo === null || otherInfo === void 0 ? void 0 : (ref = otherInfo[1]) === null || ref === void 0 ? void 0 : ref.url) || "");
                    },
                    children: [
                        /*#__PURE__*/ _jsx(IconMarkerWrapper, {
                            children: (otherInfo === null || otherInfo === void 0 ? void 0 : (ref2 = otherInfo[1]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.logo) === null || ref3 === void 0 ? void 0 : ref3.image) && /*#__PURE__*/ _jsx("img", {
                                src: requireStaticImageComponent((otherInfo === null || otherInfo === void 0 ? void 0 : (ref4 = otherInfo[1]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.logo) === null || ref5 === void 0 ? void 0 : ref5.image) || ""),
                                alt: "icon"
                            })
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            children: otherInfo[1].info || ""
                        })
                    ]
                })
            ]
        })
    });
};
export default Footer;
